'use client'

import React, { useState } from 'react'
import { Card, type CustomFlowbiteTheme, Modal } from 'flowbite-react'
import Image from 'next/image'

interface StaffCardProps {
  name: string
  title: string
  bio?: string
  profileImage?: string,
  showModel?: boolean
  modelTitle?: string
}

const customTheme: CustomFlowbiteTheme['card'] = {
  root: {
    base: 'flex rounded-lg border border-gray-200 bg-white hover:border-gray-400 hover:shadow-md',
    children: 'flex h-full flex-col justify-start gap-4 p-4',
  },
}

export default function StaffCard(
  {
    name,
    title,
    profileImage,
    bio,
    showModel = false,
    modelTitle,
  }: StaffCardProps,
) {
  const [openModal, setOpenModal] = useState(false)

  return (
    <>
      <Card onClick={() => setOpenModal(showModel)}
            theme={customTheme}
            className="max-w-sm">
        <div
          className="w-full min-h-52 h-sm flex items-center justify-center overflow-hidden bg-gray-50 rounded-lg">
          {
            profileImage &&
            <Image width={280} height={280} src={profileImage} alt=""
                   style={{
                     width: '100%',
                     height: 'auto',
                   }}
            />
          }
        </div>
        <div className="flex flex-col gap-0.5">
          <h5 className="text-2xl font-bold tracking-tight text-gray-900">
            {name}
          </h5>
          <span className="font-normal text-gray-700">{title}</span>
        </div>
        {
          (bio && bio !== '<p><br></p>') && (
            <div className="ql-snow">
              <div className="ql-editor !p-0">
                <div className="line-clamp-5"
                     dangerouslySetInnerHTML={{
                       __html: bio,
                     }}
                />
              </div>
            </div>
          )
        }
      </Card>
      <Modal show={openModal} onClose={() => setOpenModal(false)}>
        <Modal.Header>{modelTitle}</Modal.Header>
        <Modal.Body>
          <div className="space-y-6">
            <div
              className="w-60 h-60 relative h-sm flex items-center justify-center overflow-hidden bg-gray-50 rounded-lg">
              {
                profileImage &&
                <Image width={280} height={280} src={profileImage} alt=""
                       style={{
                         width: '100%',
                         height: 'auto',
                       }}
                />
              }
            </div>
            <div className="flex flex-col gap-0.5">
              <h5 className="text-2xl font-bold tracking-tight text-gray-900">
                {name}
              </h5>
              <span className="font-normal text-gray-700">{title}</span>
            </div>
            {
              (bio && bio !== '<p><br></p>') && (
                <div className="ql-snow">
                  <div className="ql-editor !p-0">
                    <div className="line-clamp-5"
                         dangerouslySetInnerHTML={{
                           __html: bio,
                         }}
                    />
                  </div>
                </div>
              )
            }
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}
